import sanitizeHTML from '../../../utils/sanitiseHTML';

const Client = ({clientSection}) => {
  return (
    <div className="section__client">
      <div className="section__client__container">
        <div className="section__client__about-us">
          <h2>{clientSection?.title}</h2>
          <div
            className="subtitle_1"
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(clientSection?.subtitle) }}
          />
        </div>
        <div className="section__client__image" data-bg={clientSection?.image?.sourceUrl} />

        <div className="section__client__contact-us">
          <a href={clientSection?.buttonLink} className="button">
            {clientSection?.buttonText}
          </a>
          <div
            className="subtitle_1 section__client__contact-us__text"
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(clientSection?.bottomText) }}
          />
        </div>
      </div>
    </div>
  );
};

export default Client;
